module.exports = __webpack_public_path__ + "static/img/banner.e241483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/化学试剂/banner.png
// module id = JBMB
// module chunks = 1